<template>
  <!-- 续期信息 -->
  <div class="wrapper">
    <div class="base">
      <div class="title">银行卡信息</div>
      <div class="list clearfix" v-if="obj.transfer">
        <div class="item">
          <div class="label">银行卡号</div>
          <div class="value">{{obj.transfer.bankCode}}</div>
        </div>
        <div class="item">
          <div class="label">持卡人</div>
          <div class="value">{{obj.transfer.bankCode}}</div>
        </div>
        <div class="item">
          <div class="label">开户行</div>
          <div class="value">xxx</div>
        </div>
        <div class="item">
          <div class="label">续期周期</div>
          <div class="value">xx</div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="title">续期信息</div>
      <div class="content">
        <Table :columns="columns" :data="tableDate" border></Table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["obj"],
  data() {
    return {
      columns: [
        {
          title: "续期账单号",
          key: "num",
          align: "center"
        },
        {
          title: "应交费日期",
          key: "code",
          align: "center"
        },
        {
          title: "宽限期满日期",
          key: "relation",
          align: "center"
        },
        {
          title: "应交保费（元）",
          key: "lp",
          align: "center"
        },
        {
          title: "状态",
          key: "lp",
          align: "center"
        },
        {
          title: "实际交费日期",
          key: "lp",
          align: "center"
        },
        {
          title: "实交保费（元）",
          key: "lp",
          align: "center"
        }
      ],
      tableDate: []
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.wrapper {
  .title {
    font-size: 16px;
    color: #3c464f;
    margin-top: 20px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .base {
    .list {
      .item {
        width: 25%;
        float: left;
        > div {
          float: left;
          &.label {
            margin-right: 25px;
          }
        }
      }
    }
  }
  .main {
    .title {
      margin-top: 30px;
    }
  }
}
</style>